import { TracingInstrumentation } from "@grafana/faro-web-tracing";

import { absoluteBackendBaseUrl } from "@/core/lib/runtime-env";

// otel only propagates trace headers to urls it was told about, so the backend
// origin has to be turned into an anchored pattern. kept separate from the
// constructor call so it can be asserted without standing in for the
// third-party instrumentation.
export function traceHeaderPropagationPatterns(): RegExp[] {
  const backendUrl = absoluteBackendBaseUrl();

  return backendUrl ? [new RegExp(`^${escapeRegExp(backendUrl)}`)] : [];
}

export function buildTracingInstrumentation(): TracingInstrumentation {
  return new TracingInstrumentation({
    instrumentationOptions: {
      propagateTraceHeaderCorsUrls: traceHeaderPropagationPatterns(),
    },
  });
}

function escapeRegExp(value: string): string {
  return value.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
}
